/** Ouvre une route SPA dans un nouvel onglet (CRA : `PUBLIC_URL` + chemin absolu). */
export function openAppRouteInNewWindow(pathFromRoot: string): void {
  const path = pathFromRoot.startsWith('/') ? pathFromRoot : `/${pathFromRoot}`;
  const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const url = `${window.location.origin}${pub}${path}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
